import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-D_LIh_94.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const BubbleSquareFilledSize16Component = (props, ref) => (jsx("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.666748 6.66663L0.667922 6.66795C0.706278 1.42644 1.71382 0.666626 8.00008 0.666626C14.4167 0.666626 15.3334 1.45829 15.3334 6.99996C15.3334 12.5416 14.4167 13.3333 8.00008 13.3333C6.71378 13.3333 5.64849 13.3015 4.76731 13.206L0.666748 15V6.66663ZM4.66675 6.19997V4.99997H11.3334V6.19997H4.66675ZM4.66675 8.86664V7.66664H10.0001V8.86664H4.66675Z", fill: "var(--magritte-ui-icon-color)" }) }) }));
const BubbleSquareFilledSize16 = hoc(forwardRef(BubbleSquareFilledSize16Component), 'BubbleSquareFilledSize16');

export { BubbleSquareFilledSize16 as default };
//# sourceMappingURL=BubbleSquareFilledSize16.js.map
